var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "蛋糕打标",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initloading,
                  expression: "initloading",
                },
              ],
              ref: "pram",
              attrs: { model: _vm.pram, "label-width": "90px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择标签：", prop: "labelIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: true,
                        placeholder: "请选择",
                        clearable: "",
                      },
                      model: {
                        value: _vm.pram.labelIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "labelIds", $$v)
                        },
                        expression: "pram.labelIds",
                      },
                    },
                    _vm._l(_vm.tagOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.labelName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }